import { LINK_OF_ALL_PAGES } from "const/common";
import Image from "next/image";
import Link from "next/link";

const DetailCard = () => (
  <div className="overflow-hidden">
    <div className="flex flex-wrap bg-primary-black py-8 px-4 md:px-10">
      <div className="w-6/12 xl:w-3/12 pb-6 xl:pb-0 pr-3">
        <Link href={LINK_OF_ALL_PAGES.services.customSoftwareDevelopment}>
          <a className="text-white">
            <div className="h-full py-4 px-2 md:px-4 rounded-lg transition-all duration-500 ease-out hover:ease-in border border-solid border-white/20 hover:border-white/100 hover:-translate-y-5">
              <div className="w-1/2 md:w-fit">
                <Image
                  height={100}
                  objectFit="contain"
                  src={"/assets/services/monitor.gif"}
                  width={100}
                  alt="monitor"
                />
              </div>
              <h2 className="text-white py-2 min-h-20 md:min-h-16 text-lg md:text-2xl">
                <span>Custom Software Development</span>
              </h2>
              <p className="mb-0 min-h-44">
                <span>
                  Build a game-changer tech solution that aligns with your
                  requirements by leveraging our software development services,
                  well-established domain expertise and technical stack. Also
                  gain full visibility in our customized software development
                  lifecycle, and effective control management practices.
                </span>
              </p>
            </div>
          </a>
        </Link>
      </div>
      <div className="w-6/12 xl:w-3/12 pb-6 xl:pb-0 pl-3 lg:pr-3">
        <Link href={LINK_OF_ALL_PAGES.services.staffAugmentation}>
          <a className="text-white">
            <div className="h-full py-4 px-2 md:px-4 rounded-lg transition-all duration-500 ease-out hover:ease-in border border-solid border-white/20 hover:border-white/100 hover:-translate-y-5">
              <div className="w-1/2 md:w-fit">
                <Image
                  height={100}
                  objectFit="contain"
                  src={"/assets/services/team-work.gif"}
                  width={100}
                  alt="team-work"
                />
              </div>
              <h2 className="text-white py-2 min-h-20 md:min-h-16 text-lg md:text-2xl">
                <span>Staff Augmentation Services</span>
              </h2>
              <p className="mb-0 min-h-44">
                <span>
                  Fulfill your staffing and scaling requisites, be it on-site or
                  off-site with our top talents and management framework for
                  distributed teams. Our trained team builds customized
                  solutions to help our clients accelerate market launch and
                  innovation to get the best success, taking care of code and
                  solutions with utmost security.
                </span>
              </p>
            </div>
          </a>
        </Link>
      </div>
      <div className="w-6/12 xl:w-3/12 pb-6 xl:pb-0 pr-3 lg:pl-3">
        <Link href={LINK_OF_ALL_PAGES.services.digitalMarketing}>
          <a className="text-white">
            <div className="h-full py-4 px-2 md:px-4 rounded-lg transition-all duration-500 ease-out hover:ease-in border border-solid border-white/20 hover:border-white/100 hover:-translate-y-5">
              <div className="min-h-20 md:min-h-24">
                <div className="w-1/2 md:w-fit">
                  <Image
                    height={100}
                    objectFit="contain"
                    src={"/assets/services/promotion.gif"}
                    width={100}
                    alt="promotion"
                  />
                </div>
              </div>
              <h2 className="text-white py-2 min-h-20 md:min-h-16 text-lg md:text-2xl">
                <span>Digital Marketing Services</span>
              </h2>
              <p className="mb-0 min-h-44">
                <span>
                  Get the results and recognition your brand deserves - as
                  rapidly, effectively, and sustainably as possible. You can
                  rely on our tried and tested strategies to yield positive
                  results every time, whether you are looking for branding and
                  leads or a higher return on ad spend, expanding your digital
                  presence and ROI.
                </span>
              </p>
            </div>
          </a>
        </Link>
      </div>
      <div className="w-6/12 xl:w-3/12 pb-6 xl:pb-0 pl-3 lg:pr-0">
        <Link href={LINK_OF_ALL_PAGES.services.itConsultationAssistance}>
          <a className="text-white">
            <div className="h-full py-4 px-2 md:px-4 rounded-lg transition-all duration-500 ease-out hover:ease-in border border-solid border-white/20 hover:border-white/100 hover:-translate-y-5">
              <div className="w-1/2 md:w-fit">
                <Image
                  height={100}
                  objectFit="contain"
                  src={"/assets/services/opinion.gif"}
                  width={100}
                  alt="opinion"
                />
              </div>
              <h2 className="text-white py-2 min-h-20 md:min-h-16 text-lg md:text-2xl">
                <span>IT Consultation & Assistance</span>
              </h2>
              <p className="mb-0 min-h-44">
                <span>
                  Our team evaluates architecture, reports on possible risks,
                  and provides improvised plans to ensure your concept or
                  technology meets your business objectives. We design a
                  solution with advanced features to scale your business and
                  beat the competition. We are here to assist you at any stage
                  of the development.
                </span>
              </p>
            </div>
          </a>
        </Link>
      </div>
    </div>
  </div>
);

export default DetailCard;
